import { render, staticRenderFns } from "./TempQuotationCreateItem.vue?vue&type=template&id=4bf334be"
import script from "./TempQuotationCreateItem.vue?vue&type=script&lang=js"
export * from "./TempQuotationCreateItem.vue?vue&type=script&lang=js"
import style0 from "./TempQuotationCreateItem.vue?vue&type=style&index=0&id=4bf334be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports